export default __webpack_public_path__ + "79192647eb8a68b8c739d81dc97b54fb.woff2";